import { render } from "./InfoCircleIcon.vue?vue&type=template&id=6b1212a6"
import script from "./InfoCircleIcon.vue?vue&type=script&lang=js"
export * from "./InfoCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__